import Actions from './actions';
import Reducer from './reducer';
import Sagas from './sagas';
import Selectors from './selectors';

export default { Actions, Reducer, Sagas, Selectors };
